import {
  getLanguageCodesSelector,
  getSong,
  getSongDDLSelector,
  getSongValidationsSelector,
} from 'app/store/SongList/selectors';
import { useResource } from 'app/utils/hooks';
import { useAppSelector } from 'app/store';
import {
  fetchLanguageCodesDDLEffect,
  fetchSongDDLEffect,
  fetchSongValidationSchemaEffect,
} from 'app/store/SongList/effects';
import { Song } from 'types/song';
import { SongDetailsForm } from '../SongDetailsForm';
import { SongDetailsFormLoader } from '../SongDetailsForm/SongDetailsFormLoader';

export const SongDetails = () => {
  const song = useAppSelector(getSong) as Song;
  const [songDDL, songDDLLoading] = useResource(
    fetchSongDDLEffect,
    getSongDDLSelector
  );

  const [songValidations, songValidationsLoading] = useResource(
    fetchSongValidationSchemaEffect,
    getSongValidationsSelector
  );

  const [languageCodes, languageCodesLoading] = useResource(
    fetchLanguageCodesDDLEffect,
    getLanguageCodesSelector
  );

  if (songDDLLoading || languageCodesLoading || songValidationsLoading) {
    return <SongDetailsFormLoader />;
  }

  if (songValidations && languageCodes && songDDL) {
    return (
      <SongDetailsForm
        song={song}
        validations={songValidations}
        languageCodes={languageCodes}
        songDDL={songDDL}
      />
    );
  }

  return null;
};
